import Cookies from '@comeon/tomcat-cookies';

/**
 * must set cookies
 * ```
 * - oneclick-optin
 * - LOCALE
 * - lastProduct
 * - session
 * ```
 *
 * @param {any} cookie
 * @returns
 */

function getCookies(cookie) {
	const cookieValue = Cookies.get(cookie);
	if (cookieValue && typeof cookieValue !== 'undefined') {
		return cookieValue;
	}
	return null;
}

function getRootDomain() {
	return window.location.hostname.replace('mobile.', '').replace('www.', '');
}

const rootDomain = () => getRootDomain();

function setCookie(cookie, value) {
	Cookies.set(cookie, value, { domain: rootDomain() });
}

function setPermanentCookie(cookie, value, expireDate) {
	Cookies.set(cookie, value, {
		domain: rootDomain(),
		expires: expireDate
	});
}

function getLocaleCode(locale) {
	let langCode = locale.substring(0, 2);
	if (locale.substring(0, 2) === 'en' && locale.substring(5, 3) !== 'XX') {
		langCode = locale.substring(5, 3).toLowerCase();
	}
	return langCode;
}

const COOKIE_CONSENT = 'CookieConsent';
const COOKIE_CATEGORY = 'CookieCategory';
const COOKIE_NECESSARY = 'necessary';

const COOKIE_PLAYER_POINTS = 'player-points';
const COOKIE_PLAYER_BALANCE = 'player-balance';
const COOKIE_PLAYER_CASINO_NET_POSITION = 'casinoNetPosition';

const isCookieConsentTrue = () => getCookies(COOKIE_CONSENT) === 'true';

const lastProduct = () => Cookies.getJSON('lastProduct');

const getLangCode = () =>
	Cookies.getJSON('locale') && Cookies.getJSON('locale').length > 0
		? `/${getLocaleCode(Cookies.getJSON('locale'))}`
		: '/';

const lovedGames = () => getCookies('lovedGames');

const recentlyPlayedGames = () => getCookies('recentlyPlayedGames');

const isoCode = () => getCookies('isocode');

const locale = () => getCookies('locale');

const justAccepted = () => getCookies('justAccepted');

const realityCheckControl = () => getCookies('RCCC');

const realityCheckPopupAcknowledgedTime = () => getCookies('RCAPCCC');

const realityCheckPopupAcknowledgementId = () => getCookies('RCAID');

/* const setRealityCheckControl = timestamp => {
	setCookie('RCCC', timestamp, { domain });
}; */

function setPlayerIsGuestCookie() {
	Cookies.set('playerIsGuest', true, { domain: rootDomain() });
}

function setDesktopCookies() {
	Cookies.set('deviceRedirection', '443', { domain: rootDomain() });
	Cookies.set('useMobile', false, { domain: rootDomain() });
}

function setShowMobileBannerCookie() {
	Cookies.set('showMobileBanner', true, { domain: rootDomain() });
}

function clearCookie(cookieName) {
	Cookies.set(cookieName, '', {
		domain: rootDomain(),
		expires: new Date(-1)
	});
}

const SHOW_APP_BANNER = 'showAppBanner';

const isShowAppBannerTrue = () => getCookies(SHOW_APP_BANNER) === 'true';
const setShowAppBannerCookie = cookieValue => {
	const threeMonthsLater = new Date();
	threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
	Cookies.set(SHOW_APP_BANNER, cookieValue, {
		domain: rootDomain(),
		expires: threeMonthsLater
	});
};

const ERROR_COUNT = 'errorCount';
const ERROR_TIMESTAMP = 'errorTimestamp';

const errorCount = () => {
	const count = getCookies(ERROR_COUNT) || 0;
	return parseInt(count, 10);
};

const errorTimestamp = () => {
	const timestamp = getCookies(ERROR_TIMESTAMP);
	return timestamp ? new Date(parseInt(timestamp, 10)) : null;
};

const setErrorCookies = (count, timestamp) => {
	Cookies.set(ERROR_COUNT, count);
	Cookies.set(ERROR_TIMESTAMP, timestamp);
};

const setErrorCookie = (resetOldValues = false) => {
	if (resetOldValues) {
		return setErrorCookies(1, Date.now());
	}

	const errors = (errorCount() || 0) + 1;
	setErrorCookies(errors, Date.now());
};

/**
 * Set last product cookie. It helps to determine what view to request from sever.
 *
 * @param {string} arg - It must be one of 'casino', 'shop' or 'sportsbook'
 */
function setNavigationCookies(arg) {
	if (arg !== undefined && arg != null && lastProduct() !== arg) {
		Cookies.set('lastProduct', arg, { path: '/' });
	}
}
/**
 * Check if bTag is present and if its different from the local storage value, update the localstorage value
 */
const backupBTag = () => {
	/* handle unsupported browser */
	if (!window.localStorage) {
		return;
	}

	const btag = getCookies('BannerTag');
	const localBtag = window.localStorage.getItem('BannerTag');
	if (btag && btag !== localBtag) {
		window.localStorage.setItem('BannerTag', btag);
	}
};

/* retrieve btag from local storage */
const getLocalBTag = () => {
	/* handle unsupported browser */
	if (!window.localStorage) {
		return;
	}
	const btag = window.localStorage.getItem('BannerTag');
	return btag;
};

const setReferrerUrl = () => {
	const referrerUrl = document.referrer;
	if (referrerUrl) {
		window.localStorage.setItem('referrerUrl', referrerUrl);
	}
};

const getReferrerUrl = () => {
	if (window.localStorage.getItem('referrerUrl')) {
		return window.localStorage.getItem('referrerUrl');
	}
	return '';
};

const showGuestWelcomePage = () => {
	if (!window.localStorage) {
		return;
	}
	return JSON.parse(window.localStorage.getItem('showGuestWelcomePage'));
};
export {
	lastProduct,
	lovedGames,
	recentlyPlayedGames,
	isoCode,
	locale,
	justAccepted,
	setNavigationCookies,
	setPlayerIsGuestCookie,
	setDesktopCookies,
	rootDomain,
	getCookies,
	getLangCode,
	setShowMobileBannerCookie,
	realityCheckControl,
	realityCheckPopupAcknowledgementId,
	realityCheckPopupAcknowledgedTime,
	COOKIE_CONSENT,
	COOKIE_CATEGORY,
	COOKIE_NECESSARY,
	COOKIE_PLAYER_POINTS,
	COOKIE_PLAYER_BALANCE,
	COOKIE_PLAYER_CASINO_NET_POSITION,
	isCookieConsentTrue,
	isShowAppBannerTrue,
	setShowAppBannerCookie,
	errorCount,
	errorTimestamp,
	setErrorCookie,
	backupBTag,
	setReferrerUrl,
	getReferrerUrl,
	getLocalBTag,
	showGuestWelcomePage,
	setCookie,
	setPermanentCookie,
	clearCookie
};
